import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diagnostic-lab',
  templateUrl: './diagnostic-lab.component.html',
  styleUrls: ['./diagnostic-lab.component.scss']
})
export class DiagnosticLabComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
